export default {
    all: 'all',
    unprocessable: 'unprocessable',
    deleted: 'deleted',
}